export default __webpack_public_path__ + "static/media/domestic-use.87276fe9.svg";